// AdSense publisher ID (public). After approval, create ad units in AdSense and paste each unit's slot ID below.
export const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "ca-pub-5583007602568527";

export const AD_SLOTS = {
  "top-banner": "",
  "bottom-banner": "",
  "home-hero": "",
  "home-mid-1": "",
  "home-mid-2": "",
  "sidebar-1": "",
  "sidebar-2": "",
  "infeed": "",
  "default-leaderboard": "",
  "default-sidebar": "",
};
